/* tslint:disable */

export interface ChangePasswordLoginRequest {
    oldPassword?: string;
    loginRequest?: LoginRequest;
}

export interface LoginResponse {
    status?: Status;
    token?: string;
    expiration?: Date;
}

export interface ClientConfig {
    environmentType?: EnvironmentType;
    enabledPermissionCategories?: PermissionCategory[];
}

export interface AdminUser extends Principal, Serializable {
    id?: number;
    email?: string;
    groups?: number[];
    password?: string;
    passwordExpired?: boolean;
    firstName?: string;
    lastName?: string;
    blocked?: boolean;
    alias?: string;
}

export interface LoginRequest {
    username?: string;
    password?: string;
}

export interface ListAdminUsersRequest extends ListRequest {
    email?: string;
    firstName?: string;
    lastName?: string;
    alias?: string;
    userGroupId?: string[];
}

export interface ListAdminUsersResponse extends ListResponse {
    items?: AdminUser[];
}

export interface Affiliate {
    id?: number;
    operatorId?: number;
    created?: Date;
    cashoutUsername?: string;
    cashoutUserId?: number;
    cashoutUpdateTime?: Date;
    email?: string;
    username?: string;
    name?: string;
    status?: AffiliateStatus;
    enabled?: boolean;
    autoPayEnabled?: boolean;
    negativeCarryoverEnabled?: boolean;
    defaultRevenueShare?: number;
    newPassword?: string;
    provider?: AffiliateProvider;
    externalId?: string;
}

export interface AffiliatesListRequest extends BaseListRequest {
    searchString?: string;
    userId?: number;
}

export interface AffiliatesListResponse extends BaseListResponse<Affiliate> {
    items?: Affiliate[];
}

export interface PayoutsListRequest extends BaseListRequest {
    affiliateId?: number;
    cashoutId?: number;
    month?: Date;
}

export interface PayoutsListResponse extends BaseListResponse<Payout> {
}

export interface AffiliatesSettings {
    id?: number;
    enabledCurrencies?: string;
    networkCostPercentage?: number;
    defaultAffiliateRevenueSharePercentage?: number;
    logoUrl?: string;
    supportEmail?: string;
    linkURL?: string;
    enabled?: boolean;
    menu?: AffiliateMenu;
    defaultProvider?: AffiliateProvider;
}

export interface PlayerListRequest extends BaseListRequest {
    from?: Date;
    to?: Date;
    username?: string;
    tracker?: string;
    userId?: number;
}

export interface PlayerListResponse extends BaseListResponse<Player> {
}

export interface Player {
    id?: number;
    created?: Date;
    playerId?: number;
    trackerCode?: string;
    username?: string;
    affiliateId?: number;
    operatorId?: number;
    trackerId?: number;
    status?: PlayerStatus;
    synchAttempts?: number;
    provider?: AffiliateProvider;
    externalId?: string;
}

export interface DataSet extends Serializable {
    points?: DataPoint[];
}

export interface MetricsListResponse extends Serializable {
    data?: MetricsData[];
}

export interface EventListRequest extends ListRequest {
    userId?: number;
    types?: EventType[];
    startDate?: Date;
    endDate?: Date;
    remoteAddress?: string;
    amountAccountRole?: string;
}

export interface EventListResponse extends ListResponse {
    items?: Event[];
}

export interface Chart {
    id?: number;
    name?: string;
    externalId?: string;
    tags?: string[];
    segmentTitles?: string;
    type?: ChartType;
}

export interface ListChartsRequest extends ListRequest {
    tag?: string;
}

export interface ListChartsResponse extends ListResponse {
    items?: Chart[];
}

export interface AuditLog extends Serializable {
    id?: number;
    timestamp?: Date;
    actorType?: AuditEntityType;
    actorId?: number;
    actorIp?: string;
    actorEmail?: string;
    targetType?: AuditEntityType;
    targetId?: number;
    eventName?: AuditEventSubType;
    description?: string;
    method?: string;
    path?: string;
    request?: string;
}

export interface ListAuditLogsRequest extends ListRequest {
    id?: number;
    actorType?: AuditEntityType;
    actorId?: number;
    actorEmail?: string;
    targetType?: AuditEntityType;
    targetId?: number;
    eventNames?: AuditEventSubType[];
    startDate?: Date;
    endDate?: Date;
}

export interface ListAuditLogsResponse extends ListResponse {
    items?: AuditLog[];
}

export interface SystemEventLogCountResponse {
    infoEventsCount?: number;
    warnEventsCount?: number;
    errorEventsCount?: number;
}

export interface SystemEventLog {
    id?: number;
    level?: Level;
    resolved?: boolean;
    message?: string;
    timestamp?: Date;
    subType?: SystemEventSubType;
    attributes?: { [index: string]: string };
}

export interface ListSystemEventLogsRequest extends ListRequest {
    id?: number;
    level?: Level;
    subType?: SystemEventSubType;
    resolved?: EventResolveStatus;
    userId?: number;
    startDate?: Date;
    endDate?: Date;
}

export interface ListSystemEventLogsResponse extends ListResponse {
    items?: SystemEventLog[];
}

export interface SystemEventTestRequest {
    level?: Level;
    message?: string;
    subType?: SystemEventSubType;
    attributes?: { [index: string]: string };
}

export interface BonusConfig {
    id?: number;
    status?: BonusStatus;
    validFromDate?: Date;
    validToDate?: Date;
    expiresAfterDays?: number;
    name?: string;
    summary?: string;
    description?: string;
    imageUrl?: string;
    translations?: BonusConfigTranslation[];
    monetaryConfig?: MonetaryConfig;
    turnoverContributions?: TurnoverContributions;
    trigger?: BonusTrigger;
    hasOfferedBonus?: boolean;
    userLabels?: BonusConfigUserLabel[];
    bonusStatusAlert?: BonusStatusAlert;
    bonusAlertDescription?: string;
}

export interface BonusConfigListRequest extends ListRequest {
    status?: BonusStatus;
    bonusVisibilityStatus?: BonusVisibilityStatus;
}

export interface BonusConfigListResponse extends ListResponse {
    items?: BonusConfig[];
}

export interface AwardBonusOfferRequest {
    id?: number;
    userId?: number;
    amount?: number;
    bonusConfigId?: number;
}

export interface BonusOffer {
    id?: number;
    userId?: number;
    timestamp?: Date;
    expires?: Date;
    amount?: number;
    currency?: string;
    bonusConfig?: BonusConfig;
    status?: BonusOfferStatus;
    turnoverRequirement?: number;
    paymentId?: string;
    offeredByAdminUserId?: number;
}

export interface UserLimitFigure {
    userId?: number;
    currencyCode?: string;
    timestamp?: Date;
    paidTotalAmount?: number;
    paidPeriodValue?: number;
    paidPeriodUnit?: PeriodTimeUnit;
}

export interface BonusOfferListRequest extends ListRequest {
    userId?: number;
    status?: BonusOfferStatus;
}

export interface BonusOfferListResponse extends ListResponse {
    items?: BonusOffer[];
}

export interface BonusTrigger {
    id?: number;
    name?: string;
    event?: string;
    triggerType?: RuleTriggerType;
    count?: number;
    expiresAfterDays?: number;
}

export interface BonusTriggerListRequest extends ListRequest {
}

export interface BonusTriggerListResponse extends ListResponse {
    items?: BonusTrigger[];
}

export interface MonetaryConfig {
    id?: number;
    name?: string;
    currencyCode?: string;
    turnoverRequirementFactor?: number;
    maxInputAmount?: number;
    awardType?: AwardType;
    awardAmountFraction?: number;
    maxWagerAmount?: number;
    minInputAmount?: number;
    partialPayoutPercentage?: number;
    maxPaidTotalAmount?: number;
    maxPaidPeriodValue?: number;
    maxPaidPeriodUnit?: PeriodTimeUnit;
    maxPaidIgnoreGlobalSettings?: boolean;
    awardTarget?: AwardTarget;
}

export interface MonetaryConfigListRequest extends ListRequest {
    currencyCode?: string;
}

export interface MonetaryConfigListResponse extends ListResponse {
    items?: MonetaryConfig[];
}

export interface SettingLimit {
    id?: number;
    currencyCode?: string;
    timestamp?: Date;
    maxPaidTotalAmount?: number;
    maxPaidPeriodValue?: number;
    maxPaidPeriodUnit?: PeriodTimeUnit;
    updatedBy?: number;
    updatedTimestamp?: Date;
}

export interface SettingLimitListRequest extends ListRequest {
    currencyCode?: string;
}

export interface SettingLimitListResponse extends ListResponse {
    items?: SettingLimit[];
}

export interface TurnoverContributions {
    id?: number;
    name?: string;
    contributions?: Contribution[];
}

export interface TurnoverContributionsListRequest extends ListRequest {
}

export interface TurnoverContributionsListResponse extends ListResponse {
    items?: TurnoverContributions[];
}

export interface UserBonusView {
    id?: number;
    expires?: Date;
    timestamp?: Date;
    totalBonusAmount?: number;
    currency?: string;
    bonusConfig?: BonusConfig;
    currentTurnover?: number;
    turnoverRequirement?: number;
    status?: UserBonusStatus;
    currentPayoutAmount?: number;
    currentTotalPayouts?: number;
    bonusOfferId?: number;
}

export interface UserBonusEventListRequest extends ListRequest {
    userBonusId?: number;
}

export interface UserBonusEventListResponse extends ListResponse {
    items?: UserBonusEvent[];
}

export interface ListUserBonusRequest extends ListRequest {
    userId?: number;
}

export interface UserBonusListResponse extends ListResponse {
    items?: UserBonusView[];
}

export interface CasinoGame {
    id?: number;
    name?: string;
    enabled?: boolean;
    mobile?: boolean;
    desktop?: boolean;
    playForFun?: boolean;
    imageUrl?: string;
    gameType?: CasinoGameType;
    aspectRatio?: CasinoGameAspectRatio;
    updated?: Date;
    externalId?: string;
    mobileExternalId?: string;
    integration?: CasinoIntegration;
    removed?: boolean;
    attributes?: { [index: string]: string };
    created?: Date;
    studio?: CasinoStudio;
    translations?: CasinoGameTranslation[];
    releaseDate?: Date;
    gameTags?: GameTag[];
    backgroundImageUrl?: string;
    description?: string;
    gameOrder?: number;
}

export interface ListCasinoGameRequest extends ListRequest {
    name?: string;
    gameIds?: number[];
    casinoGameTypes?: CasinoGameType[];
    casinoGameStudio?: CasinoStudio[];
    casinoGameTags?: GameTag[];
    releaseDateStart?: Date;
    releaseDateEnd?: Date;
    removed?: boolean;
    enabled?: boolean;
    gameOrder?: number;
}

export interface ListCasinoGameResponse extends ListResponse {
    items?: CasinoGame[];
}

export interface GameTag {
    id?: number;
    name?: string;
    nameId?: string;
}

export interface ListGameTagRequest extends ListRequest {
    name?: string;
}

export interface ListGameTagResponse extends ListResponse {
    items?: GameTag[];
}

export interface CasinoLobbyCategory {
    id?: number;
    name?: string;
    translationKey?: string;
    lobbyOrder?: number;
    types?: CasinoGameType[];
    games?: number[];
    tags?: number[];
    translations?: { [index: string]: string };
    slug?: string;
    enabled?: boolean;
}

export interface ListCasinoLobbyCategoryRequest extends ListRequest {
    name?: string;
    isEnabled?: boolean;
}

export interface ListCasinoLobbyCategoryResponse extends ListResponse {
    items?: CasinoLobbyCategory[];
}

export interface CasinoStudio {
    id?: number;
    name?: string;
    externalId?: string;
    integration?: CasinoIntegration;
    enabled?: boolean;
    imageUrl?: string;
    blockedCountries?: string;
    allowedCountries?: string;
    blockedCurrencies?: string;
    playForFunEnabled?: boolean;
    playForFunCapable?: boolean;
}

export interface ListStudioRequest extends ListRequest {
    name?: string;
}

export interface ListStudioResponse extends ListResponse {
    items?: CasinoStudio[];
}

export interface ContestListRequest extends ListRequest {
    id?: string;
    name?: string;
}

export interface ContestListResponse extends ListResponse {
    items?: Contest[];
}

export interface Contest {
    contestId?: string;
    contestType?: string;
    contestTypeName?: string;
    contestName?: string;
    createDate?: Date;
    startDate?: Date;
    endDate?: Date;
    url?: string;
    imageUrl?: string;
    backgroundImageUrl?: string;
}

export interface ContestType {
    contestType?: string;
    contestTypeName?: string;
}

export interface ContestTypeListRequest extends ListRequest {
    id?: string;
    name?: string;
}

export interface ContestTypeListResponse extends ListResponse {
    items?: ContestType[];
}

export interface Credit extends Serializable {
    id?: number;
    userId?: number;
    accountId?: number;
    request?: string;
    status?: CreditStatus;
    provider?: string;
    externalId?: string;
    originalAmount?: number;
    owedAmount?: number;
    exchangeCurrency?: string;
    exchangeRate?: number;
    created?: Date;
    updated?: Date;
    adminUserIdUpdated?: number;
    reference?: string;
}

export interface CreditsRequest {
    userId?: number;
    reference?: string;
    status?: CreditStatus;
    startDate?: Date;
    endDate?: Date;
    offset?: number;
    limit?: number;
    order?: CreditsOrder;
    ascending?: boolean;
}

export interface CreditList extends Serializable {
    nrOfResults?: number;
    items?: Credit[];
}

export interface Credentials {
    url?: string;
    secretKey?: string;
}

export interface AdminNote {
    id?: number;
    authorAdminUserId?: number;
    authorName?: string;
    type?: string;
    typeId?: string;
    comment?: string;
    created?: Date;
    archived?: boolean;
    pinned?: boolean;
}

export interface ListAdminNotesRequest extends ListRequest {
    type?: string;
    typeId?: string;
}

export interface ListAdminNotesResponse extends ListResponse {
    items?: AdminNote[];
}

export interface PushMessage {
    title?: string;
    body?: string;
    badge?: string;
    icon?: string;
    image?: string;
    silent?: boolean;
    timeToLive?: number;
    data?: PushMessageData;
}

export interface ProviderList {
    providers?: string[];
    currencyCode?: string;
}

export interface PaymentSetting {
    id?: string;
    value?: { [index: string]: PaymentSettingData };
    created?: Date;
    updated?: Date;
    comments?: string;
}

export interface ListPaymentSettingRequest extends ListRequest {
    id?: string;
}

export interface ListPaymentSettingResponse extends ListResponse {
    items?: PaymentSetting[];
}

export interface Payment {
    id?: number;
    externalPaymentId?: string;
    userId?: number;
    email?: string;
    paymentTxId?: number;
    paymentReverseTxId?: number;
    provider?: string;
    uid?: string;
    type?: PaymentType;
    status?: string;
    amount?: number;
    currency?: string;
    created?: Date;
    updated?: Date;
    attributes?: { [index: string]: string };
    log?: PaymentLog[];
    mostRecentNoteText?: string;
    pinnedNote?: boolean;
    merchantTransactionId?: string;
    agregatorTransactionId?: string;
    fee?: number;
}

export interface ListCryptoAddressLogRequest extends ListRequest {
    userId?: number;
    address?: string;
}

export interface ListCryptoAddressLogResponse extends ListResponse {
    items?: CryptoAddressLog[];
}

export interface ListPaymentsRequest extends ListRequest {
    userId?: number;
    uid?: string;
    types?: string[];
    statuses?: string[];
}

export interface ListPaymentsResponse extends ListResponse {
    items?: Payment[];
}

export interface PaymentResult {
    paymentId?: number;
    paymentUid?: string;
    result?: PaymentResultCode;
    referenceId?: string;
    message?: string;
}

export interface Bundle {
    id?: number;
    nameId?: string;
    name?: string;
    description?: string;
    imageUrl?: string;
    label?: string;
    created?: Date;
    enabled?: boolean;
    price?: Monetary;
    awardFunds1?: Monetary;
    awardFunds2?: Monetary;
    awardPokerItemId?: string;
    awardPokerItemList?: PokerItem[];
    featured?: boolean;
    type?: BundleType;
}

export interface PokerItem {
    id?: string;
    nameId?: string;
    name?: string;
    description?: string;
    imageUrl?: string;
    category?: string;
    value?: number;
    isEquippable?: boolean;
    operatorId?: number;
    allowMultiple?: boolean;
    voucherCurrencyCode?: string;
    voucherValue?: number;
}

export interface PokerItemList {
    nrOfResults?: number;
    items?: PokerItem[];
}

export interface ListBundlesRequest extends ListRequest {
}

export interface ListBundlesResponse extends ListResponse {
    items?: Bundle[];
}

export interface RequestDenied {
    userId?: number;
    userGroupIds?: number[];
    permittedCategories?: PermittedCategories;
    description?: string;
}

export interface InternalSettings {
    paymentNotificationEmail?: string;
    paymentNotifyDeposit?: boolean;
    paymentNotifyInstantWithdraw?: boolean;
    paymentNotifyWithdrawApprovementNeeded?: boolean;
    weeklySummaryEmail?: boolean;
    weeklySummaryEmailRecipients?: string;
    facebookAppSecret?: string;
    matiSecretString?: string;
    blockedCountries?: string;
    verifyIpAddresses?: boolean;
    maxIpAddressRiskLevel?: number;
    registrationIpBlockTime?: number;
    creditEnabled?: boolean;
}

export interface Settings {
    title?: string;
    cssOverrideUrl?: { [index: string]: string };
    pokerEnabled?: boolean;
    casinoEnabled?: boolean;
    sportsbookEnabled?: boolean;
    bonusEnabled?: boolean;
    ticketsEnabled?: boolean;
    racingEnabled?: boolean;
    contenfulSpaceId?: string;
    contentfulAccessToken?: string;
    requireUserChannelVerification?: boolean;
    emailSignupAvailable?: boolean;
    phoneSignupAvailable?: boolean;
    kycOnWithdrawRequired?: boolean;
    faqPageEnabled?: boolean;
    currencies?: CurrencyDefinition[];
    transferLimits?: TransferLimit[];
    facebookAppId?: string;
    useStoreInsteadOfDeposit?: boolean;
    useInfoTextSignup?: boolean;
    showCurrencySelectOnSignup?: boolean;
    freshChatEnabled?: boolean;
    freshChatWidgetToken?: string;
    freshChatHost?: string;
    freshChatConfiguration?: string;
    matiEnabled?: boolean;
    matiClientId?: string;
    bundleBonusCurrency?: string;
    skipDepositPageOnRegister?: boolean;
    forceWithdrawCurrency?: string;
    googleAnalyticsId?: string;
    googleCaptchaSiteKey?: string;
    customScripts?: string;
    acquisitionScript?: string;
    menu?: Menu;
    loginRedirectUrl?: string;
    useAmplitude?: boolean;
    amplitudeApiKey?: string;
    clientManifest?: string;
    pwaEnabled?: boolean;
    currencyOrder?: string;
    pushNotificationsEnabled?: boolean;
    loginsRequiredForPushPrompt?: number;
    noOfTimeBeforeHidingPrompt?: number;
    noOfTimeBeforePromptingAgain?: number;
    appPopupEnabled?: boolean;
    appNativePromptEnabled?: boolean;
    delayAppInstallPopup?: number;
    appInstallButtonsEnabled?: boolean;
    countryBlockEnabled?: boolean;
    pwaEnabledIOS?: boolean;
    pwaEnabledAndroid?: boolean;
    pwaEnabledWindows?: boolean;
    iosMediaJSON?: string;
    requiredUserAttributes?: UserAttributeDefinition[];
    tokenLoginEnabled?: boolean;
    sportsbookProvider?: SportsbookProvider;
    operatorName?: string;
    operatorIconUrl?: string;
    mfaEnabled?: boolean;
    contestEnabled?: boolean;
    logoutRedirectUrl?: string;
    paymentEnabled?: boolean;
    displayPendingBalanceEnabled?: boolean;
}

export interface BetLog {
    id?: number;
    timestamp?: Date;
    integration?: string;
    source?: string;
    betId?: string;
    groupId?: string;
    parentId?: string;
    userId?: number;
    created?: Date;
    gradedDate?: Date;
    name?: string;
    description?: string;
    betType?: string;
    currency?: string;
    risk?: number;
    originalPayout?: number;
    payout?: number;
    odds?: string;
    oddsFormat?: string;
    status?: string;
    selections?: string;
    request?: string;
    updated?: Date;
    updatedBy?: number;
    result?: BetLogResult;
    riskAccountRole?: AccountRole;
    originalPayoutAccountRole?: AccountRole;
    payoutAccountRole?: AccountRole;
}

export interface ListBetLogsRequest extends ListRequest {
    betId?: string;
    groupId?: string;
    parentId?: string;
    userId?: number;
    betTypes?: string[];
    currency?: string;
    oddsFormats?: string[];
    statuses?: string[];
    results?: BetLogResult[];
    startDate?: Date;
    endDate?: Date;
    riskAccountRoles?: AccountRole[];
}

export interface ListBetLogsResponse extends ListResponse {
    items?: BetLog[];
}

export interface SportsBet {
    id?: string;
    integration?: string;
    source?: string;
    groupId?: string;
    parentId?: string;
    userId?: number;
    created?: Date;
    gradedDate?: Date;
    name?: string;
    description?: string;
    betType?: BetType;
    currency?: string;
    risk?: number;
    originalPayout?: number;
    payout?: number;
    odds?: string;
    oddsFormat?: BetOddsFormat;
    status?: BetStatus;
    updated?: Date;
    updatedBy?: number;
    request?: string;
    selections?: SportsBetSelection[];
    riskAccountRole?: AccountRole;
    originalPayoutAccountRole?: AccountRole;
    payoutAccountRole?: AccountRole;
}

export interface ListBetsRequest extends ListRequest {
    id?: string;
    groupId?: string;
    parentId?: string;
    userId?: number;
    betTypes?: BetType[];
    currency?: string;
    oddsFormats?: BetOddsFormat[];
    statuses?: BetStatus[];
    startDate?: Date;
    endDate?: Date;
    riskAccountRoles?: AccountRole[];
}

export interface ListUserBetSummary extends ListResponse {
    items?: UserBetSummary[];
}

export interface ListBetsResponse extends ListResponse {
    items?: SportsBet[];
}

export interface TicketConversation {
    id?: string;
    parent_id?: string;
    timestamp?: Date;
    ticket_id?: string;
    sender?: number;
    sender_type?: TicketUserType;
    receivers?: number[];
    subject?: string;
    comment?: string;
    quote_conversation_id?: TicketQuote;
    attachments?: string[];
    sender_username?: string;
}

export interface TicketPrivateConversation {
    id?: string;
    parent_id?: string;
    timestamp?: Date;
    ticket_id?: string;
    sender?: number;
    receivers?: number[];
    subject?: string;
    comment?: string;
    quote_conversation_id?: TicketQuote;
    quote_private_conversation_id?: TicketQuote;
    attachments?: string[];
    sender_username?: string;
}

export interface Ticket {
    id?: string;
    parent_id?: string;
    parent_conversation_id?: string;
    timestamp?: Date;
    status?: TicketStatus;
    status_updated_timestamp?: Date;
    type?: TicketType;
    subtype?: TicketSubtype;
    updated_timestamp?: Date;
    updated_by?: number;
    updated_by_type?: TicketUserType;
    subject?: string;
    text?: string;
    requested_by?: number;
    submitted_by?: number;
    submitted_by_type?: TicketUserType;
    brand?: string;
    attributes?: { [index: string]: string };
    due_date?: Date;
    channel?: TicketChannel;
    followers?: number[];
    groups?: TicketGroup[];
    is_player_visible?: boolean;
    satisfaction_rate?: number;
    satisfaction_comment?: string;
    attachments?: string[];
    conversations?: TicketConversation[];
    private_conversations?: TicketPrivateConversation[];
    requestor_review_timestamp?: Date;
}

export interface TicketListRequest extends ListRequest {
    id?: string;
    parent_id?: string;
    parent_conversation_id?: string;
    statuses?: TicketStatus[];
    types?: TicketType[];
    subtypes?: TicketSubtype[];
    groups?: TicketGroup[];
    requested_by?: number;
    submitted_by?: number;
    submitted_by_type?: TicketUserType;
    subject?: string;
    text?: string;
    start_date?: Date;
    end_date?: Date;
}

export interface TicketListResponse extends ListResponse {
    items?: Ticket[];
}

export interface ActiveLocales {
    locales?: string[];
    defaultLocale?: string;
}

export interface Translation {
    id?: number;
    key?: string;
    locale?: string;
    value?: string;
    updated?: boolean;
}

export interface ListTranslationsRequest extends ListRequest {
    locale?: string;
}

export interface ListTranslationsResponse extends ListResponse {
    items?: Translation[];
}

export interface UserAttributeDefinition {
    id?: number;
    type?: AttributeType;
    attributeKey?: string;
    userWriteAccess?: UserWriteAccess;
    required?: boolean;
    minLength?: number;
    maxLength?: number;
    regex?: string;
    nameTranslationKey?: string;
    descriptionTranslationKey?: string;
    options?: string;
    defaultValue?: string;
}

export interface ListRequest extends UnorderedListRequest {
    ascending?: boolean;
    orderBy?: string;
}

export interface ListUserAttributeDefinitionResponse extends ListResponse {
    items?: UserAttributeDefinition[];
}

export interface UserLabel {
    id?: number;
    value?: string;
    description?: string;
    createdBy?: number;
    timestamp?: Date;
    updatedBy?: number;
    updatedTimestamp?: Date;
    enabled?: boolean;
}

export interface ListUserLabelsRequest extends ListRequest {
    id?: number;
    value?: string;
    description?: string;
    enabled?: boolean;
    startDate?: Date;
    endDate?: Date;
}

export interface ListUserLabelsResponse extends ListResponse {
    items?: UserLabel[];
}

export interface User {
    id?: number;
    email?: string;
    username?: string;
    loginType?: LoginType;
    blocked?: boolean;
    created?: Date;
    lastLogin?: Date;
    kycVerified?: boolean;
    termsAccepted?: boolean;
    verificationCode?: string;
    emailVerified?: boolean;
    resetPasswordRequestTimestamp?: Date;
    affiliateId?: number;
    affiliateName?: string;
    attributes?: { [index: string]: string };
    userSettings?: { [index: string]: string };
    kycStatus?: KycStatus;
    phoneNumber?: string;
    phoneNumberVerified?: boolean;
    country?: string;
    labels?: string[];
    mfaStatus?: MultiFactorAuthStatus;
    mfaProvider?: MultiFactorAuthProvider;
    createdRemoteAddress?: string;
    enabledProducts?: string[];
    creditEnabled?: boolean;
}

export interface ListUsersRequest extends ListRequest {
    searchString?: string;
    userId?: number;
    affiliateId?: number;
    kycStatus?: KycStatus[];
    searchByDate?: boolean;
    startDate?: Date;
    endDate?: Date;
    blocked?: boolean;
    labels?: string[];
}

export interface ListUsersResponse extends ListResponse {
    items?: User[];
}

export interface UserGroup {
    id?: number;
    groupPermissions?: { [index: string]: boolean };
    name?: string;
}

export interface ListUserGroupResponse extends ListResponse {
    items?: UserGroup[];
}

export interface TxBatchResult {
    batchId?: string;
    status?: TxBatchStatus;
    error?: TxBatchError;
    errorMessage?: string;
    rows?: TxBatchRowResult[];
    comment?: string;
    transactionType?: TransactionType;
}

export interface TxBatchCsvRequest {
    csv?: string;
    transactionType?: TransactionType;
    comment?: string;
}

export interface Account extends Serializable {
    id?: number;
    userId?: number;
    operatorId?: number;
    affiliateId?: number;
    information?: AccountInformation;
    status?: AccountStatus;
    type?: AccountType;
    created?: Date;
    closed?: Date;
    negativeAmountAllowed?: boolean;
    subtype?: string;
    attributes?: { [index: string]: string };
    currencyCode?: string;
}

export interface Currency extends Serializable {
    code?: string;
    fractionalDigits?: number;
    visible?: boolean;
    cryptoCurrency?: boolean;
    name?: string;
    prefixSymbol?: string;
    postfixSymbol?: string;
    irlCurrencyCode?: string;
    irlCurrencyFactor?: number;
}

export interface ListEntriesRequest extends ListRequest {
    accountId?: number;
}

export interface ListEntriesResponse extends ListResponse {
    items?: Entry[];
}

export interface AccountBalanceResult extends Serializable {
    accountId?: number;
    balance?: Money;
    accountAttributes?: { [index: string]: string };
}

export interface MultiBalanceDto extends Serializable {
    accountId?: number;
    role?: string;
    currencyCode?: string;
    amount?: number;
    amountUsdt?: number;
    exchangeRateUsdt?: number;
}

export interface ListMultiBalanceTransactionRequest extends Serializable{
    CustomerID?: string;
    CurrencyCode?: string;
    TranDateStart?: string;
    TranDateEnd?: string;
}

export interface ListMultiBalanceTransactionResponse extends Serializable {
    CustomerID?: number;
    CurrencyCode?: string;
    TranDateStart?: string;
    TranDateEnd?: string;
    TotalTransactions?: number;
    transactions?: MultiBalanceTransaction[];
}

export interface MultiBalanceTransaction extends Serializable {
    DocumentNumber?: number;
    CustomerID?: string;
    TranDateTime?: string;
    TranCode?: string;
    TranType?: string;
    Amount?: number;
    Description?: string;
    Reference?: string;
    CurrencyCode?: string;
    IsBonus?: boolean;
    ExchangeRateUsed?: number;
    CurrencyBalance?: number;
}

export interface AccountConstraints {
    types?: AccountType[];
    subtypes?: string[];
    statuses?: AccountStatus[];
}

export interface Transaction extends Serializable {
    id?: number;
    externalId?: string;
    entries?: Entry[];
    timestamp?: Date;
    comment?: string;
    attributes?: { [index: string]: string };
    metadata?: string;
}

export interface ListTransactionsRequest extends ListRequest {
    type?: TransactionSearchType;
    fromDate?: Date;
    toDate?: Date;
    idOne?: number;
    userIdOne?: boolean;
    idTwo?: number;
    userIdTwo?: boolean;
    accountId?: number;
    userId?: number;
    key?: string;
    value?: string;
}

export interface ListTransactionsResponse extends ListResponse {
    items?: Transaction[];
}

export interface ListAccountsRequest extends ListRequest {
    accountId?: number;
    userId?: number;
    statuses?: AccountStatus[];
    types?: AccountType[];
    currencies?: string[];
    subtypes?: string[];
}

export interface ListAccountsResponse extends ListResponse {
    items?: Account[];
}

export interface AccountTransferRequest {
    fromAccount?: number;
    toAccount?: number;
    amount?: number;
    comment?: string;
}

export interface TransactionResult {
    errorCode?: number;
    transactionId?: number;
    balances?: AccountBalanceResult[];
}

export interface TransferRequest {
    type?: TransferRequestType;
    accountId?: number;
    amount?: number;
    comment?: string;
    subtype?: TransferRequestSubtype;
}

export interface Principal {
    name?: string;
}

export interface Serializable {
}

export interface ListResponse {
    nrOfResults?: number;
}

export interface BaseListRequest {
    limit?: number;
    offset?: number;
    ascending?: boolean;
    orderBy?: string;
}

export interface RevenueResponse {
    timestamp?: Date;
    wager?: number;
    netResult?: number;
    deposits?: number;
    grossGamingRevenue?: number;
    bonusCost?: number;
    networkCost?: number;
    netGamingRevenue?: number;
    profit?: number;
    currency?: string;
    found?: boolean;
    playerId?: number;
    playerName?: string;
    tracker?: string;
}

export interface AffiliateMenu {
    items?: AffiliatesMenuItem[];
}

export interface DataPoint extends Serializable {
    date?: string;
    value?: number;
}

export interface MetricsData {
    date?: Date;
    value?: number;
    key?: string;
}

export interface Event {
    id?: number;
    userId?: number;
    type?: EventType;
    remoteAddress?: string;
    timestamp?: Date;
    amount?: number;
    product?: string;
    currency?: string;
    amountAccountRole?: string;
}

export interface BonusConfigTranslation {
    id?: number;
    language?: string;
    name?: string;
    summary?: string;
    description?: string;
    imageUrl?: string;
}

export interface BonusConfigUserLabel {
    id?: number;
    userLabelId?: number;
    isIncluded?: boolean;
    timestamp?: Date;
}

export interface Contribution {
    id?: number;
    product?: ContributionProduct;
    includeCasinoTags?: string;
    excludeCasinoTags?: string;
    minOdds?: number;
    maxOdds?: number;
    liveBetting?: boolean;
    preMatchBetting?: boolean;
    contributionFactor?: number;
    description?: string;
    translations?: ContributionTranslation[];
    maxContribution?: number;
    includesRefunds?: boolean;
}

export interface UserBonusEvent {
    id?: number;
    userBonusId?: number;
    timestamp?: Date;
    amount?: number;
    currency?: string;
    type?: UserBonusEventType;
    contribution?: number;
    product?: string;
    gameId?: number;
    gameName?: string;
    status?: UserBonusEventStatus;
    wagerCount?: number;
}

export interface CasinoGameTranslation {
    id?: number;
    language?: string;
    name?: string;
    imageUrl?: string;
    description?: string;
}

export interface Embeddable {
    name?: string;
    id?: number;
}

export interface PushMessageData {
    url?: string;
    campaignName?: string;
    dateOfArrival?: Date;
}

export interface PaymentSettingData {
    value?: string;
    comments?: string;
}

export interface PaymentLog {
    id?: number;
    paymentId?: number;
    timestamp?: Date;
    type?: PaymentLogEventType;
    error?: boolean;
    message?: string;
    data?: string;
    status?: PaymentStatus;
    referenceId?: string;
}

export interface CryptoAddressLog {
    id?: number;
    timestamp?: Date;
    userId?: number;
    provider?: string;
    currency?: string;
    address?: string;
}

export interface Monetary {
    currency?: string;
    amount?: number;
}

export interface PermittedCategories {
    categoryTypes?: PermissionCategory[];
    requiresWriteAccess?: boolean;
}

export interface CurrencyDefinition {
    code?: string;
    fractionalDigits?: number;
    visible?: boolean;
    cryptoCurrency?: boolean;
    name?: string;
    prefixSymbol?: string;
    postfixSymbol?: string;
    irlCurrencyCode?: string;
    irlCurrencyFactor?: number;
}

export interface TransferLimit {
    currency?: string;
    minDepositAmount?: number;
    maxDepositAmount?: number;
    minWithdrawAmount?: number;
    maxWithdrawAmount?: number;
    defaultDepositAmount?: number;
}

export interface Menu {
    items?: MenuItem[];
}

export interface SportsBetSelection {
    betId?: string;
    id?: string;
    groupId?: string;
    parentId?: string;
    created?: Date;
    categoryId?: string;
    categoryName?: string;
    event?: SportsEvent;
    description?: string;
    pitcherOption?: string;
    oddsId?: string;
    oddsName?: string;
    oddsFormat?: BetOddsFormat;
    oddsDescription?: string;
    originalOddsValue?: string;
    currentOddsValue?: string;
    isLive?: boolean;
    score?: string;
    status?: BetStatus;
    updated?: Date;
    updatedBy?: number;
    request?: string;
}

export interface UserBetSummary {
    userId?: number;
    currency?: string;
    sumOfRisk?: number;
}

export interface TicketQuote {
    id?: string;
    source?: TicketQuoteSource;
    small?: string;
    url?: string;
}

export interface UnorderedListRequest {
    limit?: number;
    offset?: number;
}

export interface TxBatchRowResult {
    row?: TxBatchRow;
    txId?: number;
    error?: TxBatchError;
}

export interface AccountInformation extends Serializable {
    name?: string;
}

export interface Entry extends Serializable {
    id?: number;
    accountId?: number;
    accountUserId?: number;
    transactionId?: number;
    timestamp?: Date;
    accountType?: AccountType;
    accountStatus?: AccountStatus;
    amount?: Money;
    resultingBalance?: Money;
    transactionComment?: string;
    transactionAttributes?: { [index: string]: string };
    transactionMetadata?: string;
}

export interface Money extends Serializable {
    currencyCode?: string;
    fractionalDigits?: number;
    amount?: number;
}

export interface BaseListResponse<E> {
    nrOfResults?: number;
    items?: E[];
}

export interface Payout {
    id?: number;
    found?: boolean;
    created?: Date;
    affiliateId?: number;
    currency?: string;
    grossRevenue?: number;
    bonusCost?: number;
    networkCost?: number;
    netRevenue?: number;
    percentage?: number;
    profit?: number;
    month?: string;
    accountId?: number;
    status?: PayoutStatus;
    progress?: PayoutProgress;
    carryOver?: number;
    affiliate?: Affiliate;
}

export interface AffiliatesMenuItem {
    type?: AffiliatesMenuItemType;
    url?: string;
    target?: string;
    name?: string;
}

export interface ContributionTranslation {
    id?: number;
    language?: string;
    description?: string;
}

export interface MenuItem {
    type?: MenuItemType;
    url?: string;
    target?: string;
    name?: string;
    translations?: { [index: string]: string };
}

export interface SportsEvent {
    eventId?: string;
    integration?: string;
    source?: string;
    parentId?: string;
    created?: Date;
    eventStartDate?: Date;
    name?: string;
    description?: string;
    sportId?: string;
    sportName?: string;
    tournamentId?: string;
    tournamentName?: string;
    status?: SportsEventStatus;
    updated?: Date;
    updatedBy?: number;
    request?: string;
}

export interface TxBatchRow {
    userId?: number;
    amount?: number;
    currency?: string;
}

export enum EventType {
    CREATED = "CREATED",
    LOGIN = "LOGIN",
    DEPOSIT = "DEPOSIT",
    WITHDRAW = "WITHDRAW",
    REVENUE = "REVENUE",
    BONUS = "BONUS",
    PASSWORDRESET = "PASSWORDRESET",
    PASSWORDUPDATE = "PASSWORDUPDATE",
    MFAENABLED = "MFAENABLED",
}

export enum TimeFrame {
    PREVIOUS_AND_CURRENT_DAY = "PREVIOUS_AND_CURRENT_DAY",
    PREVIOUS_AND_CURRENT_MONTH = "PREVIOUS_AND_CURRENT_MONTH",
}

export enum TicketStatus {
    PENDING = "PENDING",
    IN_PROGRESS = "IN_PROGRESS",
    WAITING_FOR_CUSTOMER = "WAITING_FOR_CUSTOMER",
    RESOLVED = "RESOLVED",
    CLOSED = "CLOSED",
}

export enum TicketSubtype {
    GENERAL_INFORMATION = "GENERAL_INFORMATION",
    BET_NOT_ACCEPTED = "BET_NOT_ACCEPTED",
    GRADING_REQUEST = "GRADING_REQUEST",
    LINE_REQUEST = "LINE_REQUEST",
    MISGRADES = "MISGRADES",
    CANCELLATIONS_AND_REFUNDS = "CANCELLATIONS_AND_REFUNDS",
    BAD_LINES = "BAD_LINES",
    CLIENT_REPORTS = "CLIENT_REPORTS",
    POKER_CLAIMS = "POKER_CLAIMS",
    CASINO_CLAIMS = "CASINO_CLAIMS",
    FREE_SPINS_AND_BONUS = "FREE_SPINS_AND_BONUS",
    CANCELLED_WDS_AND_ON_HOLD = "CANCELLED_WDS_AND_ON_HOLD",
    ACCOUNT_REVIEW = "ACCOUNT_REVIEW",
    WITHDRAWALS = "WITHDRAWALS",
    DEPOSITS = "DEPOSITS",
    WITHDRAWAL_ERROR = "WITHDRAWAL_ERROR",
    DEPOSIT_ERROR = "DEPOSIT_ERROR",
    RULES = "RULES",
    ROLLOVER = "ROLLOVER",
    SPECIAL_AND_MANUAL_BONUS = "SPECIAL_AND_MANUAL_BONUS",
    NON_DEPOSIT_BONUS = "NON_DEPOSIT_BONUS",
    REBATES_LOSSBACK = "REBATES_LOSSBACK",
    CONTESTS = "CONTESTS",
    SPORTSBOOK = "SPORTSBOOK",
    CASINO = "CASINO",
    POKER = "POKER",
    BONUS_FUNCTIONALITY = "BONUS_FUNCTIONALITY",
    PROPERTIES = "PROPERTIES",
    LIMITS = "LIMITS",
    SELF_EXCLUSION = "SELF_EXCLUSION",
    OWED_FUNDS = "OWED_FUNDS",
    REFER_TO_AFF_DEPT = "REFER_TO_AFF_DEPT",
    GENERAL_QUESTIONS = "GENERAL_QUESTIONS",
    LIMITS_INQUIRY = "LIMITS_INQUIRY",
    PROMOTIONS = "PROMOTIONS",
    TECHNICAL_ISSUES = "TECHNICAL_ISSUES",
    COLLUTION_REPORT = "COLLUTION_REPORT",
    HAND_DISPUTE = "HAND_DISPUTE",
    HAND_INFORMATION = "HAND_INFORMATION",
    RAKE = "RAKE",
    FREE_SPINS_INFORMATION_OR_DISPUTE = "FREE_SPINS_INFORMATION_OR_DISPUTE",
    GAME_DISPUTE = "GAME_DISPUTE",
    GAME_INFORMATION = "GAME_INFORMATION",
    CLOSED_ACCOUNT_QUESTIONS = "CLOSED_ACCOUNT_QUESTIONS",
    IP_LOGIN_REQUIREMENT = "IP_LOGIN_REQUIREMENT",
    ONGOING_SECURITY_REVIEWS = "ONGOING_SECURITY_REVIEWS",
    BET_CONTRIBUTION = "BET_CONTRIBUTION",
    BONUS_ABUSE = "BONUS_ABUSE",
    BONUS_PROFILE_UPDATE = "BONUS_PROFILE_UPDATE",
    MANUAL_BONUS = "MANUAL_BONUS",
    POKER_RAKEBACK = "POKER_RAKEBACK",
    SPECIAL_CASINO_BONUS = "SPECIAL_CASINO_BONUS",
    SPECIAL_REQUEST = "SPECIAL_REQUEST",
    VIP = "VIP",
    TWOFA = "TWOFA",
    BALANCE = "BALANCE",
    CHAT = "CHAT",
    EMAIL = "EMAIL",
    LIGHT_OR_DARK_MODE = "LIGHT_OR_DARK_MODE",
    SITE_PROFILE = "SITE_PROFILE",
    TICKETS = "TICKETS",
    VERIFICATION_CODE = "VERIFICATION_CODE",
    CLOSING_ACCOUNT = "CLOSING_ACCOUNT",
    DEPOSIT_CONFIRMATION = "DEPOSIT_CONFIRMATION",
    MANUAL_DEPOSIT_OR_DUPLICATE_WALLET = "MANUAL_DEPOSIT_OR_DUPLICATE_WALLET",
    WITHDRAWAL_QUESTIONS = "WITHDRAWAL_QUESTIONS",
    BET_PAYOUTS = "BET_PAYOUTS",
    REBATE = "REBATE",
    PAYMENT = "PAYMENT",
    LOGIN_ISSUES = "LOGIN_ISSUES",
    SITE_DOWN = "SITE_DOWN",
    OTHER = "OTHER",
}

export enum TicketType {
    SPORTSBOOK = "SPORTSBOOK",
    POKER = "POKER",
    CASINO = "CASINO",
    SECURITY = "SECURITY",
    CASHIER = "CASHIER",
    BONUS = "BONUS",
    TECHNICAL_ISSUES = "TECHNICAL_ISSUES",
    ACCOUNT = "ACCOUNT",
    AFFILIATES = "AFFILIATES",
    RACEBOOK = "RACEBOOK",
    SITE = "SITE",
    OTHER = "OTHER",
}

export enum KycStatus {
    NOT_STARTED = "NOT_STARTED",
    PENDING = "PENDING",
    REVIEW_NEEDED = "REVIEW_NEEDED",
    REJECTED = "REJECTED",
    VERIFIED = "VERIFIED",
}

export enum Product {
    POKER = "POKER",
    CASINO = "CASINO",
    SPORTSBOOK = "SPORTSBOOK",
    PAYMENT = "PAYMENT",
    // RACING = "RACING",
    // TICKETS = "TICKETS",
    // CONTEST = "CONTEST",
    WITHDRAW = "WITHDRAW",
    LIVEBETTING = "LIVEBETTING",
    LIVECASINO = "LIVECASINO"
}

export enum PermissionCategory {
    METRICS = "METRICS",
    USERS = "USERS",
    TEST = "TEST",
    ADMIN_USER_GROUPS = "ADMIN_USER_GROUPS",
    WALLET = "WALLET",
    AUDIT = "AUDIT",
    ADMIN_USERS = "ADMIN_USERS",
    OPERATOR_PROGRESSION = "OPERATOR_PROGRESSION",
    CASINO = "CASINO",
    REQUIRED = "REQUIRED",
    USER_ATTRIBUTE_CONFIG = "USER_ATTRIBUTE_CONFIG",
    ANALYTICS = "ANALYTICS",
    PAYMENTS = "PAYMENTS",
    PAYMENT_SETTINGS = "PAYMENT_SETTINGS",
    NOTES = "NOTES",
    AFFILIATES = "AFFILIATES",
    NOTIFICATIONS = "NOTIFICATIONS",
    TRANSLATIONS = "TRANSLATIONS",
    REPORTS = "REPORTS",
    BATCH_WALLET = "BATCH_WALLET",
    BONUS = "BONUS",
    USER_AUTHENTICATION = "USER_AUTHENTICATION",
    USER_LABELS = "USER_LABELS",
    ADMIN_NOTES = "ADMIN_NOTES",
    SETTINGS = "SETTINGS",
    MANUAL_BALANCE_ADJUSTMENT = "MANUAL_BALANCE_ADJUSTMENT",
    MANUAL_BONUS_AWARD = "MANUAL_BONUS_AWARD",
    BONUS_GLOBAL_SETTINGS = "BONUS_GLOBAL_SETTINGS",
    ACCOUNT_ATTRIBUTES = "ACCOUNT_ATTRIBUTES",
    ENABLED_PRODUCTS = "ENABLED_PRODUCTS",
    MANAGED_CREDIT = "MANAGED_CREDIT",
    SPORTSBETTING = "SPORTSBETTING",
    MANUAL_BONUS_BALANCE_ADJUSTMENT = "MANUAL_BONUS_BALANCE_ADJUSTMENT",
    MANUAL_DORMANT_COLLECTION = "MANUAL_DORMANT_COLLECTION",
}

export enum Status {
    SUCCESS = "SUCCESS",
    FAILURE = "FAILURE",
    PASSWORD_CHANGE_REQUIRED = "PASSWORD_CHANGE_REQUIRED",
    INVALID_PASSWORD_CHANGE = "INVALID_PASSWORD_CHANGE",
    BLOCKED = "BLOCKED",
}

export enum EnvironmentType {
    production = "production",
    test = "test",
}

export enum AffiliateStatus {
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    SUSPENDED = "SUSPENDED",
}

export enum AffiliateProvider {
    PARTNER_MATRIX = "PARTNER_MATRIX",
    LOCAL = "LOCAL",
}

export enum PlayerStatus {
    RECEIVED = "RECEIVED",
    PENDING = "PENDING",
    CONFIRMED = "CONFIRMED",
    ERROR = "ERROR",
}

export enum ChartType {
    LINE = "LINE",
    BAR = "BAR",
}

export enum AuditEntityType {
    SYSTEM = "SYSTEM",
    ADMIN = "ADMIN",
    USER = "USER",
}

export enum AuditEventSubType {
    MANUAL_BALANCE_ADJUSTMENT = "MANUAL_BALANCE_ADJUSTMENT",
    MANUAL_BONUS_AWARD = "MANUAL_BONUS_AWARD",
    PAYMENT_APPROVAL = "PAYMENT_APPROVAL",
    PAYMENT_CREATE = "PAYMENT_CREATE",
    PAYMENT_REVERSE = "PAYMENT_REVERSE",
    PLAYER_UPDATE = "PLAYER_UPDATE",
    PLAYER_MFA_DISABLED = "PLAYER_MFA_DISABLED",
    PLAYER_PRODUCT_UPDATE = "PLAYER_PRODUCT_UPDATE",
    ADMIN_USER_LOGIN_SUCCESS = "ADMIN_USER_LOGIN_SUCCESS",
    ADMIN_USER_LOGIN_FAILED = "ADMIN_USER_LOGIN_FAILED",
    ADMIN_USER_LOGOUT = "ADMIN_USER_LOGOUT",
    PLAYER_BLOCKED_UPDATE = "PLAYER_BLOCKED_UPDATE",
    BONUS_UPDATE = "BONUS_UPDATE",
    BONUS_MONETARY_CONFIG_UPDATE = "BONUS_MONETARY_CONFIG_UPDATE",
    BONUS_TRIGGER_UPDATE = "BONUS_TRIGGER_UPDATE",
    BONUS_CONTRIBUTION_UPDATE = "BONUS_CONTRIBUTION_UPDATE",
    BONUS_CONFIG_UPDATE = "BONUS_CONFIG_UPDATE",
    BONUS_OFFER_UPDATE = "BONUS_OFFER_UPDATE",
}

export enum Level {
    INFO = "INFO",
    WARN = "WARN",
    ERROR = "ERROR",
}

export enum SystemEventSubType {
    registrationBlocked = "registrationBlocked",
    payments = "payments",
    sportsbook = "sportsbook",
    casino = "casino",
}

export enum EventResolveStatus {
    RESOLVED = "RESOLVED",
    NOT_RESOLVED = "NOT_RESOLVED",
}

export enum BonusStatus {
    DISABLED = "DISABLED",
    ENABLED = "ENABLED",
    ARCHIVED = "ARCHIVED",
}

export enum BonusStatusAlert {
    GREY = "GREY",
    RED = "RED",
    YELLOW = "YELLOW",
    GREEN = "GREEN",
}

export enum BonusVisibilityStatus {
    NON_ARCHIVED = "NON_ARCHIVED",
    ARCHIVED = "ARCHIVED",
}

export enum BonusOfferStatus {
    OPEN = "OPEN",
    EXPIRED = "EXPIRED",
    CANCELED = "CANCELED",
    CLAIMED = "CLAIMED",
}

export enum PeriodTimeUnit {
    SECONDS = "SECONDS",
    MINUTES = "MINUTES",
    HOURS = "HOURS",
    DAYS = "DAYS",
}

export enum RuleTriggerType {
    ABSOLUTE_COUNT = "ABSOLUTE_COUNT",
    EVERY_TIME = "EVERY_TIME",
    MANUAL = "MANUAL",
    FIRST_DEPOSITS = "FIRST_DEPOSITS",
    AFTER_DEPOSITS = "AFTER_DEPOSITS",
    NEXT_DEPOSITS = "NEXT_DEPOSITS",
    FIRST_BONUS_CLAIMED = "FIRST_BONUS_CLAIMED",
    AFTER_BONUS_CLAIMED = "AFTER_BONUS_CLAIMED",
    NEXT_BONUS_CLAIMED = "NEXT_BONUS_CLAIMED",
}

export enum AwardType {
    CLAIMED = "CLAIMED",
    RUNNING = "RUNNING",
    COMPLETED = "COMPLETED",
}

export enum AwardTarget {
    MAIN = "MAIN",
    BONUS = "BONUS",
}

export enum UserBonusStatus {
    RUNNING = "RUNNING",
    COMPLETED = "COMPLETED",
    CANCELED = "CANCELED",
    EXPIRED = "EXPIRED",
    CANCELED_WITH_PAYOUT = "CANCELED_WITH_PAYOUT",
}

export enum CasinoGameType {
    ARCADE_GAMES = "ARCADE_GAMES",
    SLOTS = "SLOTS",
    LIVE_CASINO = "LIVE_CASINO",
    TABLE_GAMES = "TABLE_GAMES",
    VIDEO_POKER = "VIDEO_POKER",
    OTHER = "OTHER",
}

export enum CasinoGameAspectRatio {
    R_16_9 = "R_16_9",
    R_4_3 = "R_4_3",
    R_3_4 = "R_3_4",
    R_9_16 = "R_9_16",
}

export enum CasinoIntegration {
    BOOONGO = "BOOONGO",
    CUBEIA = "CUBEIA",
    SA_GAMING = "SA_GAMING",
    NUCLEUS = "NUCLEUS",
    FLOW_GAMING = "FLOW_GAMING",
    QTECH = "QTECH",
    SPRIBE = "SPRIBE",
    CONCEPTGAMING = "CONCEPTGAMING",
    SLOTX = "SLOTX",
    NITROGEN_GAMES = "NITROGEN_GAMES",
    RTG = "RTG",
    GSOFT = "GSOFT",
}

export enum CreditStatus {
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    COMPLETED = "COMPLETED",
}

export enum CreditsOrder {
    ID = "ID",
    USER_ID = "USER_ID",
}

export enum PaymentType {
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    AUTH = "AUTH",
    BONUS = "BONUS",
    CORRECTION = "CORRECTION",
    WITHDRAWAL_FEES = "WITHDRAWAL_FEES",
}

export enum PaymentResultCode {
    OK = "OK",
    DECLINED = "DECLINED",
    DECLINED_REQUEST_ALREADY_OPEN = "DECLINED_REQUEST_ALREADY_OPEN",
    DECLINED_NO_DEPOSIT_FOUND = "DECLINED_NO_DEPOSIT_FOUND",
    DECLINED_NO_TARGET_ADDRESS_SET = "DECLINED_NO_TARGET_ADDRESS_SET",
    DECLINED_DEPOSITS_WAITING_TO_CLEAR = "DECLINED_DEPOSITS_WAITING_TO_CLEAR",
    ERROR = "ERROR",
}

export enum BundleType {
    purchase = "purchase",
    signOnBonus = "signOnBonus",
}

export enum SportsbookProvider {
    SONG88 = "SONG88",
    ULTRAPLAY = "ULTRAPLAY",
}

export enum BetLogResult {
    PENDING = "Pending",
    SUCCESS = "Success",
    ERROR = "Error",
    UNKNOWN = "unknown",
}

export enum AccountRole {
    MAIN = "MAIN",
    BONUS = "BONUS",
}

export enum BetType {
    SINGLE = "Single",
    COMBO = "Combo",
    SYSTEM = "System",
    IFBET = "Ifbet",
    REVERSEBET = "Reversebet",
    TEASER = "Teaser",
    UNKNOWN = "unknown",
}

export enum BetOddsFormat {
    DECIMAL = "decimal",
    AMERICAN = "american",
    FRACTIONAL = "fractional",
    ASIAN = "asian",
    UNKNOWN = "unknown",
}

export enum BetStatus {
    REQUESTED = "Requested",
    APPROVED = "Approved",
    PENDING = "Pending",
    UNGRADED = "Ungraded",
    PUSH = "Push",
    CANCELLED = "Cancelled",
    WIN = "Win",
    HALF_WIN = "HalfWin",
    LOSS = "Loss",
    HALF_LOSE = "HalfLose",
    UNKNOWN = "Unknown",
    DECLINE = "Decline",
}

export enum TicketUserType {
    ADMIN = "ADMIN",
    PLAYER = "PLAYER",
    SYSTEM = "SYSTEM",
}

export enum TicketChannel {
    EMAIL = "EMAIL",
    CHAT = "CHAT",
    WEBFORM = "WEBFORM",
}

export enum TicketGroup {
    SUPPORT = "SUPPORT",
    FRAUD = "FRAUD",
    CASINO = "CASINO",
    POKER = "POKER",
    WITHDRAWALS = "WITHDRAWALS",
    VIP = "VIP",
}

export enum AttributeType {
    PUBLIC = "PUBLIC",
    PRIVATE = "PRIVATE",
    SYSTEM = "SYSTEM",
    SYSTEM_INTERNAL = "SYSTEM_INTERNAL",
}

export enum UserWriteAccess {
    NONE = "NONE",
    CREATE = "CREATE",
    CREATE_AND_UPDATE = "CREATE_AND_UPDATE",
}

export enum LoginType {
    MANUAL = "MANUAL",
    FACEBOOK = "FACEBOOK",
    TOKEN = "TOKEN",
}

export enum MultiFactorAuthStatus {
    DISABLED = "DISABLED",
    PENDING = "PENDING",
    ENABLED = "ENABLED",
}

export enum MultiFactorAuthProvider {
    OTP = "OTP",
    EMAIL = "EMAIL",
    SMS = "SMS",
}

export enum TxBatchStatus {
    FAILED = "FAILED",
    PREPARED = "PREPARED",
    RUNNING = "RUNNING",
    FINISHED = "FINISHED",
}

export enum TxBatchError {
    USER_NOT_FOUND = "USER_NOT_FOUND",
    INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS",
    BAD_INPUT = "BAD_INPUT",
    WRONG_CURRENCY = "WRONG_CURRENCY",
    BATCH_RUNNING = "BATCH_RUNNING",
    GENERAL = "GENERAL",
    BATCH_NOT_FOUND = "BATCH_NOT_FOUND",
    PARTIAL = "PARTIAL",
    BAD_STATUS = "BAD_STATUS",
}

export enum TransactionType {
    POKER_DEPOSIT = "POKER_DEPOSIT",
    POKER_WITHDRAW = "POKER_WITHDRAW",
    CASINO_BET = "CASINO_BET",
    CASINO_WIN = "CASINO_WIN",
    ROLLBACK = "ROLLBACK",
    MANUAL = "MANUAL",
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    WITHDRAWAL_CANCEL = "WITHDRAWAL_CANCEL",
    CORRECTION = "CORRECTION",
    DEPOSIT_CANCEL = "DEPOSIT_CANCEL",
    UNKNOWN = "UNKNOWN",
    SPORTSBOOK_BET = "SPORTSBOOK_BET",
    SPORTSBOOK_SETTLEMENT = "SPORTSBOOK_SETTLEMENT",
    SPORTSBOOK_CANCELLATION = "SPORTSBOOK_CANCELLATION",
    SPORTSBOOK_UNSETTLEMENT = "SPORTSBOOK_UNSETTLEMENT",
    SPORTSBOOK_DECLINED = "SPORTSBOOK_DECLINED",
    SPORTSBOOK_REFUND = "SPORTSBOOK_REFUND",
    CASINO_BET_WIN = "CASINO_BET_WIN",
    RACING_BET = "RACING_BET",
    RACING_SETTLEMENT = "RACING_SETTLEMENT",
    RACING_REBATE = "RACING_REBATE",
    API = "API",
    BONUS = "BONUS",
    CLAWBACK = "CLAWBACK",
    WITHDRAWAL_FEES = "WITHDRAWAL_FEES",
}

export enum AccountStatus {
    OPEN = "OPEN",
    CLOSED = "CLOSED",
}

export enum AccountType {
    SESSION_ACCOUNT = "SESSION_ACCOUNT",
    STATIC_ACCOUNT = "STATIC_ACCOUNT",
    SYSTEM_ACCOUNT = "SYSTEM_ACCOUNT",
    OPERATOR_ACCOUNT = "OPERATOR_ACCOUNT",
    AFFILIATE_ACCOUNT = "AFFILIATE_ACCOUNT",
}

export enum TransactionSearchType {
    DEFAULT = "DEFAULT",
    ATTRIBUTE = "ATTRIBUTE",
}

export enum TransferRequestType {
    CREDIT = "CREDIT",
    DEBIT = "DEBIT",
}

export enum TransferRequestSubtype {
    BONUS = "BONUS",
    SPORTSBET = "SPORTSBET",
    CASINO = "CASINO",
    POKER = "POKER",
    TRANSFER = "TRANSFER",
    TEST_FUNDS = "TEST_FUNDS",
    REBATE = "REBATE",
    DEPOSIT = "DEPOSIT",
    WITHDRAWAL = "WITHDRAWAL",
    COLLECTION = "COLLECTION",
    CONTESTS = "CONTESTS",
    SERVICE_PAYMENT = "SERVICE_PAYMENT",
    RACEBOOK = "RACEBOOK",
}

export enum ContributionProduct {
    CASINO = "CASINO",
    SPORTSBOOK = "SPORTSBOOK",
    POKER = "POKER",
    RACING = "RACING",
}

export enum UserBonusEventType {
    STARTED = "STARTED",
    GAME = "GAME",
    PAYOUT = "PAYOUT",
    COMPLETED = "COMPLETED",
    CANCELED = "CANCELED",
    EXPIRED = "EXPIRED",
    ERROR = "ERROR",
}

export enum UserBonusEventStatus {
    COMPLETED = "COMPLETED",
    PENDING = "PENDING",
    CANCELED = "CANCELED",
    IGNORE = "IGNORE",
}

export enum PaymentLogEventType {
    INITIATED = "INITIATED",
    CALLBACK_RECEIVED = "CALLBACK_RECEIVED",
    VERIFICATION_FAILED = "VERIFICATION_FAILED",
    DECLINED = "DECLINED",
    INTERNAL_TRANSFER_COMPLETE = "INTERNAL_TRANSFER_COMPLETE",
    INTERNAL_TRANSFER_FAILED = "INTERNAL_TRANSFER_FAILED",
    CANCELED = "CANCELED",
    FAILED = "FAILED",
    COMPLETED = "COMPLETED",
    RESOLVED = "RESOLVED",
    GENERIC = "GENERIC",
}

export enum PaymentStatus {
    INITIATED = "INITIATED",
    PENDING = "PENDING",
    FAILED = "FAILED",
    FAILED_PERMANENTLY = "FAILED_PERMANENTLY",
    COMPLETED = "COMPLETED",
    DECLINED = "DECLINED",
    CANCELED = "CANCELED",
    RESOLVED = "RESOLVED",
    PLACEHOLDER = "PLACEHOLDER",
    APPLIED_WAITING_TO_CLEAR = "APPLIED_WAITING_TO_CLEAR",
}

export enum TicketQuoteSource {
    PRIVATE = "PRIVATE",
    PUBLIC = "PUBLIC",
}

export enum PayoutStatus {
    FAILED = "FAILED",
    COMPLETED = "COMPLETED",
    RUNNING = "RUNNING",
    PENDING = "PENDING",
    CARRIED_OVER = "CARRIED_OVER",
}

export enum PayoutProgress {
    STARTED = "STARTED",
    PENDING_INTERNAL_TRANSACTION = "PENDING_INTERNAL_TRANSACTION",
    COMPLETED_INTERNAL_TRANSACTION = "COMPLETED_INTERNAL_TRANSACTION",
    PENDING_REMOTE_WALLET = "PENDING_REMOTE_WALLET",
    COMPLETED_REMOTE_WALLET = "COMPLETED_REMOTE_WALLET",
    ZERO_AMOUNT = "ZERO_AMOUNT",
    NEGATIVE_CARRY_OVER = "NEGATIVE_CARRY_OVER",
    CARRIED_OVER = "CARRIED_OVER",
    RECEIVED_CARRY_OVER = "RECEIVED_CARRY_OVER",
    DONE = "DONE",
}

export enum AffiliatesMenuItemType {
    LINK = "LINK",
    IFRAME = "IFRAME",
}

export enum MenuItemType {
    POKER = "POKER",
    CASINO = "CASINO",
    SPORTSBOOK = "SPORTSBOOK",
    RACING = "RACING",
    CUSTOM = "CUSTOM",
    CONTEST = "CONTEST",
    PAYMENT = "PAYMENT",
}

export enum SportsEventStatus {
    CREATED = "Created",
    PENDING = "Pending",
    INPROGRESS = "Inprogress",
    CANCELLED = "Cancelled",
    PROCESSED = "Processed",
    UNKNOWN = "unknown",
}
